



















import { Component, Vue, Emit, Prop } from 'nuxt-property-decorator'
import IconButton from '~/components/shared/buttons/IconButton.vue'

@Component({
  components: {
    IconButton,
  },
})
export default class MapPitchButtons extends Vue {
  @Prop({ default: '2d' }) defaultButton: string
  @Prop({ default: 0 }) pitch: number

  viewButton: string = '2d'

  mounted() {
    this.viewButton = this.defaultButton
  }

  @Emit('onClicked')
  onClicked(pitch: number, buttonId: string) {
    this.viewButton = buttonId
    return pitch
  }
}
